import WithResponsiveRendering from "@/modules/common/components/wrappers/with-responsive-rendering";
import Desktop from "./desktop";
import Mobile from "./mobile";

const PropertyTrackPage = WithResponsiveRendering({
  DesktopComponent: Desktop,
  MobileComponent: Mobile,
});
export default PropertyTrackPage;
